import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Container, Button } from "@mui/material";
import constructionImage from "../img/contruction.png";

const FeatureComingSoon = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: "80vh",
          textAlign: "center",
          padding: { xs: 2, sm: 0 },
        }}
      >
        <Typography variant="h4" gutterBottom marginTop={4}>
          Feature Coming Soon
        </Typography>
        <Typography variant="body1">
          We're working hard to bring you this exciting new feature. Stay tuned!
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: {xs:'50vhh', sm: '60vh', md: '70vh'},
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <img
            src={constructionImage}
            alt="Under Construction"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
        <Button
          color="primary"
          variant="contained"
          size="medium"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>
    </Container>
  );
};

export default FeatureComingSoon;
